import { render, staticRenderFns } from "./MoveModal.vue?vue&type=template&id=3cc8831c&scoped=true&"
import script from "./MoveModal.vue?vue&type=script&lang=js&"
export * from "./MoveModal.vue?vue&type=script&lang=js&"
import style0 from "./MoveModal.vue?vue&type=style&index=0&id=3cc8831c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc8831c",
  null
  
)

export default component.exports